import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const StatisticsRoot = styled('div', {
  width: '100%',
  background: '$secondary-150',
  paddingBottom: '100px',
  paddingTop: '30px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  gap: '$3',
  '@bp2': {
    gap: '$6',
    paddingBottom: '80px',
    paddingTop: '80px',
  },
})

export const StatisticWrapper = styled('div', {
  zIndex: 2,
  width: '100%',
  maxWidth: '300px',
  margin: 'auto',
  marginBottom: '18px',
  textAlign: 'center',
  '@bp2': {
    borderTop: '2px solid $quaternary-200',
    margin: 'auto',
    maxWidth: '920px',
    padding: '16px 0px',
    '&:last-child': {
      borderBottom: '2px solid $quaternary-200',
    },
  },
})

export const Blob7Wrapper = styled('div', {
  position: 'absolute',
  width: '210px',
  bottom: '-20px',
  left: '0px',
  zIndex: 0,
  display: 'none',
  '@bp2': {
    display: 'block',
  },
})

export const Blob8Wrapper = styled('div', {
  position: 'absolute',
  right: '0px',
  top: '-20px',
  zIndex: 0,
  width: '210px',
  display: 'none',
  '@bp2': {
    display: 'block',
  },
})

export const Subtitle = styled(Text, {
  margin: 'auto',
  width: '100%',
  maxWidth: '290px',
  '@bp2': {
    margin: '12px auto 12px auto',
    maxWidth: 'none',
  },
})

export const Title = styled(Text, {
  width: '100%',
  margin: 'auto',
  maxWidth: '200px',
  '@bp2': {
    maxWidth: 'none',
  },
  variants: {
    size: {
      h1: {
        fontSize: '$h2',
        '@bp2': { fontSize: '$h1' },
      },
    },
  },
})

export const DesktopWrapper = styled('div', {
  display: 'none',
  '@bp2': {
    display: 'block',
  },
})

export const MobileWrapper = styled('div', {
  '@bp2': { display: 'none' },

  '& .slick-dots li button:before': {
    fontSize: '12px',
  },

  '& .slick-dots li.slick-active button:before': {
    color: '$primary-450',
    opacity: 1,
  },
})

export const CarouselItem = styled('div', {
  margin: 'auto',
})

export const Span = styled('span', {
  color: '$primary-500',
})
